module.exports = __webpack_public_path__ + "img/ag-island.7903e970.png";